var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-overview"},[_vm._t("new-project-dialog"),_c('div',{staticClass:"projects-overview-action-bar"},[_vm._t("action_bar")],2),_c('div',{staticClass:"projects-overview-projects",style:(`
      grid-template-columns: repeat(auto-fill, minmax(min(${_vm.on_site_width || 480}px, 100%), 1fr));
      padding: ${_vm.padding || '10px'};
    `)},[_vm._t("projects")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }